import { i18n } from "@/i18n";
import GlobalMixin from "@/mixins/global";
import { AbilityBuilder } from "@casl/ability";
import { abilitiesPlugin } from "@casl/vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-pro/css/all.min.css";
import "@lottiefiles/lottie-player";
import "swiper/swiper-bundle.css";
import VCalendar from "v-calendar";
import vClickOutside from "v-click-outside";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
import VueDragscroll from "vue-dragscroll";
import FlagIcon from "vue-flag-icon";
import GSignInButton from "vue-google-signin-button";
import VueIntercom from "vue-intercom";
import { default as msalPlugin } from "vue-msal-browser";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { SlickItem, SlickList } from "vue-slicksort";
import vueSocketIO, { VueSocketOptions } from "vue-socket.io";
import App from "./App.vue";
import "./extensions";
import "./globalComponentRegistration";
import {
  AuthorizeModels,
  CheckAssetTokenValidBeforeRouterChange,
  SetLastUrl,
  SetMetaTagFromRouter,
} from "./helper/routerHelper";
import router from "./router";
import { DatadogRumService } from "./service/datadog/datadogRumService";
import store from "./store";

const msalConfig = {
  auth: {
    tenant: process.env.VUE_APP_Microsoft_Tenant,
    clientId: process.env.VUE_APP_Microsoft_Client,
    authority: `https://login.microsoftonline.com/common`,
    redirectUri: process.env.VUE_APP_PeakPayroll,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
    secureCookies: false,
    claimsBasedCachingEnabled: false,
  },
};

Vue.use(msalPlugin, msalConfig);

Vue.use(VueAwesomeSwiper);

Vue.use(GSignInButton);

Vue.use(VueIntercom, { appId: process.env.VUE_APP_PeakIntercom });

Vue.component("multiselect", Multiselect);

Vue.use(Croppa);

Vue.use(vClickOutside);

Vue.use(VCalendar, {
  componentPrefix: "v",
  backgroundColor: "#282C34",
  border: "1px solid #dadada",
});

Vue.use(FlagIcon);

Vue.component("SlickList", SlickList);
Vue.component("SlickItem", SlickItem);

Vue.mixin(GlobalMixin);

interface CustomVueSocketOptions extends VueSocketOptions {
  options?: any;
}

Vue.use(
  new vueSocketIO({
    debug: false,
    connection: process.env.VUE_APP_PeakNotification,
    vuex: {
      store,
      actionPrefix: "SOCKET_",
      mutationPrefix: "SOCKET_",
    },
    options: {
      autoConnect: false,
    },
  } as CustomVueSocketOptions)
);

function defineAbilityFor() {
  const { can, cannot, build } = new AbilityBuilder();
  return build();
}
const ability = defineAbilityFor();

Vue.use(abilitiesPlugin, ability);

Vue.use(VueDragscroll);

Vue.config.productionTip = false;
router.beforeEach(async (to, from, next) => {
  await CheckAssetTokenValidBeforeRouterChange(from);
  AuthorizeModels(to.name);
  SetLastUrl(to);
  SetMetaTagFromRouter(to);
  next();
});

router.onError((error) => {
  const regex = new RegExp(/Loading .* failed\./i);
  if (regex.test(error.message)) {
    window.location.href = `${window.location.origin}/update.html?v=${new Date().getTime()}`;
  }
});

DatadogRumService.Init();

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
